import Axios from "./axios";
import { paths } from "./paths";
import ENV from "../Environments";
import { processErrorInfoState } from "../utils/api";
import { getAuthHeaders } from "../utils/utility";

const getTemplate = async (templateName) => {
	const params = {
		templateName: templateName,
	};
	const response = await Axios.get(paths.getTemplate, {
		params: params,
	});
	return response?.data?.responses?.body;
};

const getMockTemplate = async (journeyName) => {
	const response = await Axios.get(
		`http://10.5.74.75:8081/mockUtility/mockserver/getTemplate/templateName=${journeyName}`
	);
	return response?.responses?.body;
};

const getRailData = async (endPoint, params = {}) => {
	const response = await Axios.get(endPoint, {
		params: params,
	});
	return response?.data?.responses?.body;
};

const getNMSData = async (endPoint, params = {}) => {
	const response = await Axios.get(endPoint, {
		params: params,
	});
	return response?.data?.responses?.body;
};

const getPublicKey = async (endPoint, params = {}) => {
	const response = await Axios.get(endPoint, {
		params: params,
	});
	return response?.data;
};

const getLeadDetails = async (data) => {
	const response = await Axios.get(paths.getLeadDetails, {
		params: {
			leadId: data?.leadId,
			msisdn: data?.alternateNumber,
			serviceName: "FetchPincodeDetails",
			projectName: "ECAF",
		},
	});
	const flag = processErrorInfoState(response?.data?.body);
	if (!flag) return {};
	return response?.data?.body?.body;
};

const createDraftOrder = async (body) => {
	const response = await Axios.post(paths.createDraftOrder, body);
	return response;
};

const ecafPOIVerification = async (formData) => {
    const URL = ENV.getEcafCommonsBaseUrl() + paths.ecafPOIVerification;
	const response = await Axios.post(URL, formData, {
		headers: getAuthHeaders(),
	});
	return response;
};

const ecafPOIUpload = async (formData) => {
    const URL = ENV.getEcafCommonsBaseUrl() + paths.ecafPOIUpload;
	const response = await Axios.post(URL, formData, {
		headers: getAuthHeaders(),
	});
	return response;
};

const liveVideoSubmission = async (formData) => {
    const URL = ENV.getEcafMediaBaseUrl() + paths.liveVideoSubmission;
	const response = await Axios.post(URL, formData, {
		headers: getAuthHeaders(),
	});
	return response;
};

export {
	getTemplate,
	getMockTemplate,
	getRailData,
	getNMSData,
	getPublicKey,
	getLeadDetails,
	createDraftOrder,
	ecafPOIVerification,
	liveVideoSubmission,
	ecafPOIUpload,
};
